import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lib-admit-status-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './admit-status-badge.component.html',
  styleUrls: ['./admit-status-badge.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdmitStatusBadgeComponent {
  @Input() identifierCode: string | null | undefined = null;
  @Input() label: string | null | undefined = null;

  private readonly knownCodeColors = new Map<string, string>([
    ['ADMIT', '#0d9488'],
    ['DISCHARGE-INITD', '#f59e0b'],
    ['DISCHARGED', '#dc2626'],
    ['PENDING', '#475569'],
    ['ACK-PEND', '#26bfb1'],
    ['NA', '#dfe1e6'],
  ]);

  get badgeStyles(): Record<string, string> {
    const code = (this.identifierCode ?? '').trim().toUpperCase();
    const bgColor = this.knownCodeColors.get(code) ?? '#6b7280';

    return {
      'background-color': bgColor,
      color: this.getReadableTextColor(bgColor),
    };
  }

  private getReadableTextColor(hexColor: string): string {
    const hex = hexColor.replace('#', '');
    if (hex.length !== 6) {
      return '#ffffff';
    }

    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    return luminance > 0.6 ? '#111827' : '#ffffff';
  }
}
